import { render, staticRenderFns } from "./treatmentCreateOrder.html?vue&type=template&id=316cb38d&scoped=true&"
import script from "./treatmentCreateOrder.js?vue&type=script&lang=js&"
export * from "./treatmentCreateOrder.js?vue&type=script&lang=js&"
import style0 from "./treatmentCreateOrder.scss?vue&type=style&index=0&id=316cb38d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cb38d",
  null
  
)

export default component.exports